export default class SDAStandBy {
    constructor(data = {}) {
        this.PartnerMove_ID = data.PartnerMove_ID || null
        this.PartnerBrandName = data.PartnerBrandName || ''
        this.LastTimeTry = data.LastTimeTry || null
        this.RejectReason = data.RejectReason || ''
    }
} 